export interface ModelWithId {
  id: number;
}

export interface NameIdBasicModel extends ModelWithId {
  n: string; // Name
}

export interface FileUploadModel {
  file: File | undefined;
}

export enum ConfigurationGroupDeviceType {
  X1 = 'X1',
  X9 = 'X9',
  IVU = 'IVU',
  IVUPlus = 'IVUPlus',
  Generic = 'Generic',
}

export enum SoftwareStatus {
  ShowAll = 'ShowAll',
  OutOfDate = 'OutOfDateOnly',
  UpToDate = 'UpToDateOnly',
}

export enum HealthStatus {
  ShowAll = 'ShowAll',
  ActiveFaults = 'ActiveFaults',
  NoActiveFaults = 'NoActiveFaults',
}

export enum GeofenceStateParam {
  ShowAll = 'ShowAll',
  Normal = 'Normal',
  RequireAttention = 'RequireAttention',
}

export enum ObjectType {
  Unknown = 'Unknown',
  Truck = 'Truck',
  Dozer = 'Dozer',
  Grader = 'Grader',
  Drill = 'Drill',
  MediumVehicle = 'MediumVehicle',
  LargeLoader = 'LargeLoader',
  Shovel = 'Shovel',
  Scraper = 'Scraper',
  SmallHeavy = 'SmallHeavy',
  DragLine = 'DragLine',
  PersonnelTag = 'PersonnelTag',
  LightVehicle = 'LightVehicle',
  Stationary = 'Stationary',
  TestStation = 'TestStation',
  ShovelWithHeading = 'ShovelWithHeading',
  OtherHeading = 'OtherHeading',
  SelfTest = 'SelfTest',
  PersonnelTagTestStation = 'PersonnelTagTestStation',
  WaterCart = 'WaterCart',
  ServiceTruck = 'ServiceTruck',
  WheelDozer = 'WheelDozer',
  Crane = 'Crane',
  StemmingTruck = 'StemmingTruck',
  SmallWheelLoader = 'SmallWheelLoader',
  MaintenanceVehicle = 'MaintenanceVehicle',
}

export enum SafetyAlertType {
  ManDown = 'ManDown',
  Duress = 'Duress',
}

export interface SafetyAlertParams {
  safetyAlertType: SafetyAlertType;
  safetyAlertAcknowledged: boolean | null;
}

export const ValidNameRegex = /^[a-zA-Z0-9-_.\u0020]+$/;
export const ValidGeofenceNameRegex = /^[a-zA-Z0-9À-ÖØ-öø-ÿ-_.\u0020//]+$/;
export const ValidVersionRegex = /^[a-zA-Z0-9-_.\u0020]+$/;
export const hexColorRegex = /^#([A-Fa-f0-9]{6})$/;
